import { request } from '../client';

// Stateless — recomputes authoritative pricing server-side. Does not reserve
// stock; stock is only reserved at order placement (see endpoints/orders.js).
export const quoteCart = (items) => request('/cart/quote', { method: 'POST', body: { items } });
